module.exports = __webpack_public_path__ + "img/icon-zxyy@2x.6d6db045.png";